// action - state management
import * as actionTypes from "../actions/actionTypes";

export const initialState = {
  centralLoading: false,
};

// ==============================|| COMPANY REDUCER ||============================== //

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CENTRAL_LOADER:
      return {
        ...state,
        centralLoading: action.payload,
      };
    default:
      return state;
  }
};

export default loaderReducer;
